import React from 'react';
import { Plus, Minus } from 'lucide-react';
import PropTypes from 'prop-types';

const ArrayFieldTemplate = props => {
  const { className, disabled, items, onAddClick, title, uiSchema } = props;

  const isHidden = uiSchema?.items?.['ui:hidden'];
  if (isHidden) return null;

  const visibilityStyle = isHidden ? { display: 'none' } : {};

  const buttonBaseClass =
    'h-[22px] w-[22px] min-h-[22px] min-w-[22px] border-0 p-0 shadow-none inline-flex items-center justify-center';

  return (
    <div className={className} style={visibilityStyle}>
      {items &&
        items.map((element) => (
          <div key={element.index} style={visibilityStyle}>
            <div className="row items-center">
              <div className="col-11">
                <label
                  className="mb-[0.5rem] mt-[0.3vh] block font-['Open_Sans'] text-[12px] font-bold text-[#212529]"
                  htmlFor={element.children.props.idSchema?.$id}
                >
                  {`${title} ${element.index + 1}`}
                </label>
                <div>{element.children}</div>
              </div>

              <div className="col-1">
                {items.length > 1 && (
                  <div className="mb-[12px] flex justify-end">
                    <button
                      disabled={disabled}
                      type="button"
                      className={`${buttonBaseClass} rounded-full bg-[#E93F36] text-white hover:opacity-80`}
                      onClick={element.onDropIndexClick(element.index)}
                      data-cy={`${String(title).toLowerCase()}-remove`}
                      title="Remover"
                    >
                      <Minus size={14} strokeWidth={3} />
                    </button>
                  </div>
                )}

                {element.index === items.length - 1 && (
                  <div className="flex justify-end">
                    <button
                      disabled={disabled}
                      type="button"
                      className={`${buttonBaseClass} rounded-full bg-[#5882C1] text-white hover:opacity-80`}
                      onClick={onAddClick}
                      data-cy={`${String(title).toLowerCase()}-add`}
                      title="Adicionar"
                    >
                      <Plus size={14} strokeWidth={3} />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

ArrayFieldTemplate.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  items: PropTypes.array.isRequired,
  onAddClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  uiSchema: PropTypes.object,
};

ArrayFieldTemplate.defaultProps = {
  className: '',
  disabled: false,
  uiSchema: {},
};

export default ArrayFieldTemplate;
